import { Box, Heading, Text } from '@miro-site/core';
import React from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FaqItem = styled(Box).attrs({
  $mb: 24
}).withConfig({
  displayName: "FaqItems__FaqItem",
  componentId: "sc-bsow16-0"
})(["&:last-child{margin-bottom:0;}"]);
var Question = styled(Text).attrs({
  $styles: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 26,
    marginBottom: 8
  }
}).withConfig({
  displayName: "FaqItems__Question",
  componentId: "sc-bsow16-1"
})({});
var Answer = styled(Text).attrs({
  $styles: {
    fontSize: 18,
    lineHeight: 26
  }
}).withConfig({
  displayName: "FaqItems__Answer",
  componentId: "sc-bsow16-2"
})({});

var FaqItems = function FaqItems(_ref) {
  var title = _ref.title,
      items = _ref.items;
  return /*#__PURE__*/_jsxs(Box, {
    $mt: [40, 60, 60, 60],
    children: [/*#__PURE__*/_jsx(Heading, {
      $variant: "h3",
      $mb: 24,
      children: title
    }), items.map(function (item) {
      return /*#__PURE__*/_jsxs(FaqItem, {
        children: [/*#__PURE__*/_jsx(Question, {
          as: "h3",
          children: item.question
        }), /*#__PURE__*/_jsx(Answer, {
          children: item.answer
        })]
      }, item.question);
    })]
  });
};

export default FaqItems;